module.exports = {
          srcSet: __webpack_public_path__ + "ebfc0be86bb02b53cf6f35a4a08307b1-1168.png"+" 1168w",
          images:[ {path: __webpack_public_path__ + "ebfc0be86bb02b53cf6f35a4a08307b1-1168.png",width: 1168,height: 248}],
          src: __webpack_public_path__ + "ebfc0be86bb02b53cf6f35a4a08307b1-1168.png",
          toString:function(){return __webpack_public_path__ + "ebfc0be86bb02b53cf6f35a4a08307b1-1168.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/ACeL3P0rjuH/KYnZ/iqF0v8Cb8b/JV+v/6pMfv9cQFz+cXRw/0BfdfsAD3DD/RVuuv8SZ7H+FWSp/wRZoP8zVY//wW6M/5l+k/7Go4D/TFRh+2WyLn4L8Kv+AAAAAElFTkSuQmCC",
          width: 1168,
          height: 248
        }